import { createContext, useContext } from 'react';
const FormContext = createContext({});
export const useForm = () => useContext(FormContext);
export const FormProvider = FormContext.Provider;
//# sourceMappingURL=useForm.js.map